<template>
    <v-app>
        <v-app-bar
                app
                color="#e35d32"
                dark
                clipped-left
        >
            <div class="d-flex align-center">
                <v-btn depressed @click="$router.go(-1)" color="transparent white--text" v-if="hasHistory()">
                    <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                <h3>
                    <template>
          <span class="hidden-md-and-down">
          ETC Ellerau -
            </span>
                        <span class="hidden-lg-and-up">
          ETC -
            </span>
                    </template>
                    {{title}}
                </h3>
            </div>

            <v-spacer></v-spacer>
            <v-app-bar-nav-icon
                    class="hidden-lg-and-up"
                    @click.stop="showNav = !showNav"
            />

        </v-app-bar>

        <v-navigation-drawer
                v-model="showNav"
                color="#e35d32"
                app
                dark
                clipped
        >
            <v-divider></v-divider>

            <NavEntries :nav-items="sideNav"></NavEntries>


        </v-navigation-drawer>
        <v-main>

            <!-- Provides the application the proper gutter -->

                <!-- If using vue-router -->
                <router-view></router-view>
        </v-main>
        <v-footer v-if="!cookies" padless app class="pa-2" color="black white--text">Wir verwenden nur technische Cookies, die zum Betrieb der Webseite erforderlich sind!<v-btn block @click.stop="acceptCookies()" color="yellow">Ok</v-btn></v-footer>

        <v-bottom-navigation
                app
                background-color="#e35d32"
                class="hidden-lg-and-up"
                light
        >
            <v-btn v-for="nav in bottomNav" :key="nav.title" exact light :disabled="isInactive(nav)" :to="nav.to" v-if="!nav.external">
                <span class="white--text darken-1">{{nav.title}}</span>
                <v-icon class="white--text darken-1">{{nav.icon}}</v-icon>
            </v-btn>
          <v-btn v-for="nav in bottomNav" :key="nav.title" exact light :disabled="isInactive(nav)" :href="nav.link" v-if="nav.external" target="_blank">
            <span class="white--text darken-1">{{nav.title}}</span>
            <v-icon class="white--text darken-1">{{nav.icon}}</v-icon>
          </v-btn>
        </v-bottom-navigation>
    </v-app>
</template>

<script>
    import {mapState} from 'vuex'
    import NavEntries from "./components/NavEntries";

    export default {
        name: 'App',
        components: {NavEntries},
        computed: {
            ...mapState(['navigation_items', 'title', 'titlePrefix']),
            bottomNav: function () {
                return this.navigation_items.filter((n) => {
                    return n.bottom
                })
            },
            sideNav: function () {
                return this.navigation_items.filter((n) => {
                    return n.drawer
                })
            },
            cookies: function () {
                return this.$store.state.cookies
            }
        },
        data: () => ({
            showNav: true
        }),
        methods: {
            hasHistory() {
                return this.$store.state.history.length > 0
            },
            acceptCookies () {
                this.$store.commit('ACCEPT_COOKIES', true)
                localStorage.setItem('etc_ellerau_cookies', true)
            },
            isInactive (nav) {
                if (!nav.cookies) {
                    return false
                } else {
                    return !this.cookies
                }
            }
        },
        created() {
            this.$store.commit('ACCEPT_COOKIES', localStorage.getItem('etc_ellerau_cookies'))
            this.showNav = this.$vuetify.breakpoint.lgAndUp
            document.title = `${this.titlePrefix}${this.title}`
        },
        watch: {
            'title': function (val) {
                document.title = `${this.titlePrefix}${val}`
            }
        }
    };
</script>

